<template>
  <div>
    <v-card color="grey lighten-1 white--text">
      <v-layout align-center row>
        <v-flex xs1 pl-4></v-flex>
        <v-flex xs2 md2 pl-4>Name</v-flex>
        <v-flex xs1 md1 pl-3>Cost</v-flex>
        <v-flex xs2 md2 pl-3>Date Span</v-flex>
        <v-flex xs3 md2 pl-3>Description</v-flex>
        <v-flex xs1 md1 pl-3>Tiers</v-flex>
      </v-layout>
    </v-card>
    <draggable v-model="loyaltyRewards" @change="orderChanged">
      <v-card
        v-for="loyaltyReward in loyaltyRewards"
        :key="loyaltyReward.id"
        :color="loyaltyReward.enabled ? 'white' : 'grey lighten-2'"
      >
        <v-layout v-if="loyaltyReward.external_promotion != null" align-center row>
          <v-flex xs1 pl-3>
            <img
              style="width: 50px;"
              v-if="loyaltyReward.picture != null"
              :src="loyaltyReward.picture"
            />
          </v-flex>
          <v-flex xs2 md2 pl-3>
            <p>
              <b>{{loyaltyReward.external_promotion.name}}</b>
            </p>
          </v-flex>
          <v-flex xs1 md1 pl-3>{{ loyaltyReward.cost }}</v-flex>
          <v-flex xs1 md2 pl-3>
            <p>{{loyaltyReward.external_promotion.start_date}} -> {{loyaltyReward.external_promotion.end_date }}</p>
          </v-flex>
          <v-flex xs3 md2 pl-3>{{ loyaltyReward.external_promotion.description }}</v-flex>
          <v-flex
            xs3
            md3
            pl-3
          >{{ tier(loyaltyReward.minimum_tier_id)}} -> {{tier(loyaltyReward.maximum_tier_id) }}</v-flex>
          <v-flex xs4 md1 pr-2>
            <v-layout justify-end>
              <v-card-actions>
                <v-btn icon ripple @click="edit(loyaltyReward.id)">
                  <v-icon color="grey lighten-1">edit</v-icon>
                </v-btn>
              </v-card-actions>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout v-if="loyaltyReward.promotion != null" align-center row>
          <v-flex xs1 pl-3>
            <img
              style="width: 50px;"
              v-if="loyaltyReward.picture != null"
              :src="loyaltyReward.picture"
            />
          </v-flex>
          <v-flex xs2 md2 pl-3>
            <p>
              <b>{{loyaltyReward.promotion.name}}</b>
            </p>
          </v-flex>
          <v-flex xs1 md1 pl-3>{{ loyaltyReward.cost }}</v-flex>
          <v-flex xs2 md2 pl-3>
            <p>{{loyaltyReward.promotion.start_date}} -> {{loyaltyReward.promotion.end_date }}</p>
          </v-flex>
          <v-flex xs3 md2 pl-3>{{ loyaltyReward.promotion.description }}</v-flex>
          <v-flex
            xs3
            md3
            pl-3
          >{{ tier(loyaltyReward.minimum_tier_id)}} -> {{tier(loyaltyReward.maximum_tier_id) }}</v-flex>

          <v-flex xs4 md1 pr-2>
            <v-layout justify-end>
              <v-card-actions>
                <v-btn icon ripple @click="edit(loyaltyReward.id)">
                  <v-icon color="grey lighten-1">edit</v-icon>
                </v-btn>
              </v-card-actions>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "loyalty_reward_list",
  components: {
    draggable
  },
  props: {
    loyaltyRewards: Array,
    loading: Boolean
  },
  data: function() {
    return {
      pagination: this.paginationProp,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Description",
          align: "left",
          sortable: false,
          value: "description"
        },
        {
          text: "Duration",
          align: "left",
          sortable: false,
          value: "duration"
        },
        {
          text: "Discount",
          align: "left",
          sortable: false,
          value: "discount"
        },
        {
          text: "Cost",
          align: "left",
          sortable: false,
          value: "cost"
        },
        {
          text: "Enabled",
          align: "left",
          sortable: false,
          value: "enabled"
        }
      ],
      loyaltyTiers: []
    };
  },
  mounted: function() {
    this.getLoyaltyTiers();
  },
  methods: {
    goToPromotion: function(id) {
      this.$router.push(`/settings/promotion/edit/${id}`);
    },
    tier: function(id) {
      console.log(id);
      var lt = this.loyaltyTiers.find(function(lt) {
        return lt.id == id;
      });

      if (lt == null) {
        return "";
      }

      return lt.name;
    },
    doNothing: function() {},
    discount: function(promotion) {
      if (promotion.discount_type == "percentage") {
        return promotion.discount_percentage + "%";
      } else if (promotion.discount_type == "fixed_amount") {
        return "£" + promotion.discount_fixed / 100;
      }
    },
    getLoyaltyTiers: async function() {
      try {
        let url = `${this.$store.state.apiUrl}/settings/loyalty_tiers/getAll`;

        let response = await axios.get(url, {
          params: {}
        });
        let loyaltyTiers = response.data.loyalty_tiers;

        loyaltyTiers.sort(function(a, b) {
          return a.point_threshold - b.point_threshold;
        });

        this.loyaltyTiers = loyaltyTiers;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get loyalty tiers " + error);
      }
    },
    orderChanged: function() {
      this.$emit("orderChange", this.loyaltyRewards);
    },
    edit: function(id) {
      this.$router.push("/settings/loyalty_rewards/edit/" + id);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
